
import { Component } from 'vue-property-decorator';
import TrafficSourceCreateForm from './create.vue';
import { Send } from '@/components/form-base';
import { pick } from 'lodash';
import reportUtils from '@/views/reports/report-utils';
import ApiServices from '@/services';

@Component
export default class Edit extends TrafficSourceCreateForm {
  child: boolean = true;
  integrationsData: any[] = [];

  reportUtils = reportUtils(this);

  get modalTitle(){
    return this.t('Edit traffic source')
  }

  async load() {
    this.traffic_source_id = this.data.id || this.$store.getters.selectedItem.id;

    await this.trafficSourceApi.get(this.traffic_source_id).then((data: any) => {
      this.form = pick(data, [
        'name',
        'status',
        'postbackUrl',
        'extClickIdParam',
        'extClickIdPlaceholder',
        'costParam',
        'costPlaceholder',
        'created',
        'updated',
        'updatedBy',
        'custom1Param',
        'custom1Placeholder',
        'custom1Name',
        'custom1Masking',
        'custom2Param',
        'custom2Placeholder',
        'custom2Name',
        'custom2Masking',
        'custom3Param',
        'custom3Placeholder',
        'custom3Name',
        'custom3Masking',
        'custom4Param',
        'custom4Placeholder',
        'custom4Name',
        'custom4Masking',
        'custom5Param',
        'custom5Placeholder',
        'custom5Name',
        'custom5Masking',
        'custom6Param',
        'custom6Placeholder',
        'custom6Name',
        'custom6Masking',
        'custom7Param',
        'custom7Placeholder',
        'custom7Name',
        'custom7Masking',
        'custom8Param',
        'custom8Placeholder',
        'custom8Name',
        'custom8Masking',
        'custom9Param',
        'custom9Placeholder',
        'custom9Name',
        'custom9Masking',
        'custom10Param',
        'custom10Placeholder',
        'custom10Name',
        'custom10Masking',
        'trafficLossPercent',
        'trackImpressions',
        'useTrafficLoss',
        'postbackSendConfirmStatus',
        'postbackSendNewStatus',
        'postbackSendChargebackStatus',
        'postbackSendDeclineStatus',
        'workspaceId',
        'postbackPercent',
        'tags',
        'integrationId',
      ]);

      if(!this.form.integrationId){
        this.form.integrationId = ''
      }

      return data;
    });
  }

  loadData() {
    this.edit = true;
    this.$store.commit('loading', true);

    this.load()
      .then((data: any) => {
        this.chips = this.getDefaultChips();
        this.changePostbackUrl();

        this.show = true;
        this.$store.commit('loading', false);

        this.oldHash = this.getCurrentHash();
      })
      .finally(() => this.$store.commit('loading', false));
  }

  @Send()
  submit() {
    this.$store.commit('loading', true);
    return this.trafficSourceApi.putUpdate(this.traffic_source_id, this.processForm(this.form))
      .then(async (data: any) => {
        await ApiServices.getUserProfile();
        const { id } = data;

        this.oldHash = this.getCurrentHash();

        this.reportUtils.updateName('traffic-sources', id);
        this.$store.commit('loading', false);
        this.bus.emit('refresh-report');
        this.bus.emit('toast-success', this.t('Traffic Source has been changed'));

        this.close();
      })
      .finally(() => {
        this.$store.commit('loading', false);
      });
  }

}
